const inspection = {
    state: {
        PUBLIC_ACTIVE: 0
    },
    actions: {
        SET_PUBLIC_ACTIVE(state,value){
            state.PUBLIC_ACTIVE = value
        }
    },
    mutations: {

    },
    getters: {
        getAh(state) {
            return state.ah
        }
    },
    namespaced: true
}
export default inspection